import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface FactProps {
  label: string;
  /** `ReactNode` porque há valor com sufixo, link ou tarja do modo discreto. */
  children: ReactNode;
  /** `sm` na carteira de documento, que é mais compacta que os cards de área. */
  size?: "md" | "sm";
  /** Cor do valor — validade vencida, saldo negativo. */
  valueClassName?: string;
  className?: string;
}

/**
 * Um fato rotulado: o rótulo miúdo em cima, o valor embaixo.
 *
 * É a estrutura mais repetida do Painel — matrícula, escola, CNS, unidade,
 * telefone, número da CNH, categoria, validade, placa, saldo. Estava escrita à
 * mão em cada card e já divergia: o mesmo par aparecia com o valor em
 * `text-body-md` num lugar e `text-body-sm` noutro sem que nada justificasse.
 *
 * Renderiza `dt`/`dd`, então o bloco em volta precisa ser um `<dl>`.
 */
export function Fact({ label, children, size = "md", valueClassName, className }: FactProps) {
  return (
    <div className={className}>
      <dt className="text-body-xs text-fg-muted">{label}</dt>
      <dd
        className={cn(
          size === "sm" ? "text-body-sm text-fg-default" : "text-body-md text-fg-strong",
          valueClassName,
        )}
      >
        {children}
      </dd>
    </div>
  );
}
